import { apiClient } from './client';
import type {
  ApiResponse,
  Ticket,
  TicketWithImages,
  CreateTicketRequest,
  RectifyTicketRequest,
  TrackingUpdateRequest,
  TicketFilter,
  PaginatedResponse,
  TicketStatistics,
} from '@shared/types';

export const ticketApi = {
  create: (data: CreateTicketRequest) =>
    apiClient.post<ApiResponse<{ id: number; ticket_no: string }>>('/tickets', data),

  list: (params?: TicketFilter) => {
    const filtered: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(params || {})) {
      if (v !== undefined && v !== null && v !== '') {
        filtered[k] = v;
      }
    }
    return apiClient.get<ApiResponse<PaginatedResponse<Ticket>>>('/tickets', { params: filtered });
  },

  detail: (id: number) =>
    apiClient.get<ApiResponse<TicketWithImages>>(`/tickets/${id}`),

  rectify: (id: number, data: RectifyTicketRequest) =>
    apiClient.put<ApiResponse<void>>(`/tickets/${id}/rectify`, data),

  tracking: (id: number, data: TrackingUpdateRequest) =>
    apiClient.put<ApiResponse<void>>(`/tickets/${id}/tracking`, data),

  verify: (id: number) =>
    apiClient.put<ApiResponse<void>>(`/tickets/${id}/verify`),

  close: (id: number) =>
    apiClient.put<ApiResponse<void>>(`/tickets/${id}/close`),

  remove: (id: number) =>
    apiClient.delete<ApiResponse<void>>(`/tickets/${id}`),
};

export const statisticsApi = {
  get: () =>
    apiClient.get<ApiResponse<TicketStatistics & { today_total: number; today_rectified: number }>>('/statistics'),

  trend: () =>
    apiClient.get<ApiResponse<Array<{ date: string; total: number; rectified: number }>>>('/statistics/trend'),
};
